import { Loader } from "../customplugins/loader.js";

declare global {
    interface Window {
        attachFilterEvents: () => void;
        applyFilters: () => void;
    }
}

document.addEventListener("DOMContentLoaded", () => {

    (window as any).attachFilterEvents()

    const preselected = document.querySelectorAll<HTMLInputElement>(".filter-checkbox:checked");
    if (preselected.length > 0) {
        window.applyFilters();
    }

    let page: number = 1;
    let loading: boolean = false;
    let hasMore: boolean = true;

    const productView = document.getElementById("ProductView") as HTMLElement;

    window.addEventListener("scroll", () => {

        if (loading || !hasMore) return;

        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.body.offsetHeight;

         const selected: { attribute: string, optionId: number }[] = [];

    document.querySelectorAll(".filter-checkbox:checked").forEach(cb => {
        const el = cb as HTMLInputElement;
      
        selected.push({
            attribute: el.dataset.attribute || "",
            optionId: Number(el.value)
        });
    });
        var jsondata = JSON.stringify(selected)
        if (windowHeight + scrollTop >= documentHeight - 350) {

            page++;
            loading = true;
            Loader.show();

            fetch(`/Products/GetProductsViewComponent`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ Filters: jsondata, PageNumber: page, RowCount: 12 })
            })
                .then((res: Response) => res.text())
                .then((html: string) => {
                   
                    let temp: HTMLDivElement | null = document.createElement("div");
                    temp.innerHTML = html;

                    const products = temp.querySelectorAll(".product-card");

                    if (products.length === 0) {
                        hasMore = false;
                        Loader.hide();
                        loading = false;
                        return;
                    }
                    temp = null;
                    productView.insertAdjacentHTML("beforeend", html);
                    Loader.hide();
                    loading = false;
                })
                .catch(() => {
                    loading = false;
                    Loader.hide();
                });
        }
    });


    initPackageToggle();

});

let ispackage=0
function initPackageToggle(): void {

    const packageToggle =
        document.getElementById("packageToggle") as HTMLInputElement | null;

    if (!packageToggle) return;

    if (packageToggle && ispackage==1) {
        packageToggle.checked = true;
    }
    packageToggle.addEventListener("change", () => {
        ispackage=0
        if (packageToggle.checked == true) {
            ispackage=1
        }
        const filterCheckboxes =
            document.querySelectorAll<HTMLInputElement>(".filter-checkbox");

        filterCheckboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });
        (window as any).debouncedApplyFilters();
    });
}
(window as any).applyFilters = async function () {

    const selected: { attribute: string, optionId: number }[] = [];

    document.querySelectorAll(".filter-checkbox:checked").forEach(cb => {
        const el = cb as HTMLInputElement;

        selected.push({
            attribute: el.dataset.attribute || "",
            optionId: Number(el.value)
        });
    });
    var jsondata = JSON.stringify(selected)
    console.log("Selected:", selected);
    Loader.show();
    const productCall = fetch(`/Products/GetProductsViewComponent`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ Filters: jsondata, PageNumber: 1, RowCount: 12, ispackage: ispackage })
    }).then(res => res.text());

    const filterCall = fetch(`/Products/GetFiltersViewComponent`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(jsondata)
    }).then(res => res.text());

    Promise.all([productCall, filterCall])
        .then(([productHtml, filterHtml]) => {

            const productView = document.getElementById("ProductView");
            if (productView) {
                productView.innerHTML = productHtml;
            }

            const categoryDiv = document.getElementById("catagoryDiv");
            if (categoryDiv) {
                categoryDiv.innerHTML = filterHtml;
            }

            (window as any).attachFilterEvents();
            initPackageToggle()
            Loader.hide();
        })
        .catch(err => {
            console.error("Error:", err)
            Loader.hide();
        });
};


(window as any).attachFilterEvents = async function () {
    const checkboxes = document.querySelectorAll(".filter-checkbox");

    checkboxes.forEach(cb => {
        cb.addEventListener("change", () => {
            ispackage = 0;
            (window as any).debouncedApplyFilters();
        });
    });
};

        (window as any).debouncedApplyFilters = debounce(() => {
            (window as any).applyFilters();
        }, 500);
function debounce<T extends (...args: any[]) => void>(
    func: T,
    delay: number
): (...args: Parameters<T>) => void {
    let timer: ReturnType<typeof setTimeout>;

    return (...args: Parameters<T>) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, delay);
    };
}


